const ua = navigator.userAgent

/** iOS手机 */
export const iOS = /\(i[^;]+;( U;)? CPU.+Mac OS X/i.test(ua)

/** 安卓手机 */
export const Android = /(Android)|(Adr)/i.test(ua)

/** 微信浏览器 */
export const wechat = /micromessenger/i.test(ua)

/** iOS微信浏览器 */
export const iOSWechat = iOS && wechat

/** 安卓微信浏览器 */
export const AndroidWechat = Android && wechat
